import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW2200Model } from './kymw2200.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from '../../../../../src/app/shared/pless-alert/pless-alert.component';
import { CheckSendOCRDataService } from '../kymw2200/api-services/check-send-ocr-data.service';
import { SendOCRDataService } from '../kymw2200/api-services/send-ocr-data.service';
import { UpdateMailAddressService } from './api-services/update-mail-address.service';
import { CodeComboBoxComponent } from '../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';

/**
 * OCRデータメール送信画面
 *
 * 提供時：
 * app/main/main.component.ts
 *
 * @export KYMW2200Component
 * @class KYMW2200Component
 * @implements {OnInit}
 */
@Component({
  selector: 'app-kymw2200',
  templateUrl: './kymw2200.component.html',
  styleUrls: ['./kymw2200.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class KYMW2200Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txt_orderCode', { static: true }) txt_orderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_CodeValueName', { static: true }) cmb_CodeValueName: CodeComboBoxComponent;
  @ViewChild('txt_MailAddress', { static: true }) public txt_MailAddress: ElementRef;
  @ViewChild('btn_RegistAddress', { static: true }) btn_RegistAddress: ElementRef;
  @ViewChild('btn_Set', { static: true }) btn_Set: ElementRef;

  // Model定義
  kymw2200Model: KYMW2200Model = new KYMW2200Model;

  // 親画面からの連携値
  param: any;

  /**
   * コンストラクタ
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public checkSendOCRDataService: CheckSendOCRDataService,
    public sendOCRDataService: SendOCRDataService,
    public updateMailAddressService: UpdateMailAddressService,
    public kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  ngOnInit(): void {
    this.kymw2200Model.kymw2200Component = this;
    this.componentName = 'KYMW2200';

    setTimeout(() => {
      this.plessEnabledSetting();
    });
  }

  // 活性・非活性制御処理
  public plessEnabledSetting() {
    // 初期表示時の活性・非活性制御
    this.plessEnabled(this.btn_RegistAddress, false);                           // アドレス登録ボタン
    this.plessEnabled(this.btn_Set, false);                                     // 実行ボタン
  }

  /**
   * テキスト入力「受注コード」チェンジイベント
   *
   * @memberof KYMW2200Component
   */
  public eventOrderCode_CHANGEHandler(): void {
    // ボタン「実行」の活性状態を設定
    this.setSetButtonEnabled();
  }

  /**
   * コンボボックス「OCR印刷会社」チェンジイベント
   */
  public eventCodeValue_CHANGEHandler(): void {
    this.kymw2200Model.mailAddress = this.cmb_CodeValueName.reserve1;

    // ボタン「アドレス登録」の活性状態を設定
    this.setRegistAddressButtonEnabled();
    // ボタン「実行」の活性状態を設定
    this.setSetButtonEnabled();
  }

  /**
   * テキスト入力「メールアドレス」チェンジイベント
   */
  public eventMailAddress_CHANGEHandler(): void {
    // ボタン「アドレス登録」の活性状態を設定
    this.setRegistAddressButtonEnabled();
    // ボタン「実行」の活性状態を設定
    this.setSetButtonEnabled();
  }

  /**
   * ボタン「アドレス登録」クリックイベント
   *
   * @memberof KYMW2200Component
   */
  public eventRegistAddress_CLICKHandler(): void {
    const vo = {
      CodeValue:    '',
      MailAddress:  '',
    };

    // OCR印刷会社
    vo.CodeValue = this.cmb_CodeValueName.selectedCodeValue;
    // メールアドレス
    vo.MailAddress = this.kymw2200Model.mailAddress;

    // メールアドレス反映処理
    this.updateMailAddressService.execute(this.kymw2200Model, vo);
  }

  /**
   * 実行イベント
   *
   * @memberof KYMW2200Component
   */
  public eventSet_CLICKHandler(): void {
    this.kymw2200Model.mailAddress = this.txt_MailAddress.nativeElement.value;

    // 確認メッセージを表示
    this.dialogService.openAlertGetMessage('Q0141', null,
    (closeDetail) => {
      this.eventAlert1_CLICKHandler(closeDetail);
    });
  }

  /**
   * メール送信(実行)処理確認メッセージイベント
   *
   * @memberof KYMW2200Component
   */
  public eventAlert1_CLICKHandler(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      const vo = {
        OrderCode: '',
        CatalogID: '',
        PrintCompany: '',
        MailAddress: '',
      };

      // 受注コード
      vo.OrderCode = this.kymw2200Model.orderCode;
      // 企画回（翌週配達）
      vo.CatalogID = this.txt_orderCode.selectedCatalogID;
      // OCR印刷会社名
      vo.PrintCompany = this.cmb_CodeValueName.selectedCodeName;
      // メールアドレス
      vo.MailAddress = this.kymw2200Model.mailAddress;
      // メール送信処理
      this.checkSendOCRDataService.execute(this.kymw2200Model, vo, (data: any) => {
        this.executeSendOCRData(vo, data, this.txt_orderCode.selectedCatalogID);
      });
    }
  }

  /**
   * メール送信処理 処理続行確認メッセージイベント
   *
   * @memberof KYMW2200Component
   */
  public eventAlert2_CLICKHandler(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      const vo = {
        OrderCode:    '',
        CatalogID:    '',
        PrintCompany: '',
        MailAddress:  '',
      };

      // 受注コード
      vo.OrderCode = this.kymw2200Model.orderCode;
      // 企画回（翌週配達）
      vo.CatalogID = this.txt_orderCode.selectedCatalogID;
      // OCR印刷会社名
      vo.PrintCompany = this.cmb_CodeValueName.selectedCodeName;
      // メールアドレス
      vo.MailAddress = this.kymw2200Model.mailAddress;
      // メール送信処理
      this.sendOCRDataService.execute(this.kymw2200Model, vo);
    }
  }

  /**
   * ボタン「アドレス登録」の活性状態を設定
   *
   * @memberof KYMW2200Component
   */
  private setRegistAddressButtonEnabled(): void {
    // メールアドレスが入力されていない場合、メールアドレスが変更されてない場合のみ非活性にする
    if (PlessViewUtilsSub.isEmpty(this.kymw2200Model.mailAddress)
      || (this.cmb_CodeValueName.reserve1 === this.kymw2200Model.mailAddress)) {
      this.plessEnabled(this.btn_RegistAddress, false);                         // アドレス登録ボタン
    } else {
      this.plessEnabled(this.btn_RegistAddress, true);                          // アドレス登録ボタン
    }
  }

  /**
   * ボタン「実行」の活性状態を設定
   *
   * @memberof KYMW2200Component
   */
  private setSetButtonEnabled(): void {
    // メールアドレスが入力されている場合のみ活性にする
    if (!PlessViewUtilsSub.isEmpty(this.kymw2200Model.mailAddress) &&
      this.txt_orderCode.isValidOrderCode()) {
        this.plessEnabled(this.btn_Set, true);                                  // 実行ボタン
    } else {
      this.plessEnabled(this.btn_Set, false);                                   // 実行ボタン
    }
  }

  /**
   * コンボボックス「OCR印刷会社」のメールアドレス反映
   *
   * @memberof KYMW2200Component
   */
  public setMailAddressReflect(): void {
    // OCR印刷会社のメールアドレスに変更後のメールアドレスを反映する
    this.cmb_CodeValueName.reserve1 = this.kymw2200Model.mailAddress;
    // ボタン「アドレス登録」の活性状態を設定
    this.setRegistAddressButtonEnabled();
  }

  /**
   * メール送信を行う。
   * 必要に応じて、処理続行確認メッセージを表示する。
   *
   * @memberof KYMW2200Component
   */
  public executeSendOCRData(vo: any, checkResultRec: any, lbl_DelivCatalogId: any): void {
    // OCR印刷会社のメールアドレスに変更後のメールアドレスを反映する
    this.cmb_CodeValueName.reserve1 = this.kymw2200Model.mailAddress;

    // 工程管理NOが「07」未満の媒体が存在する場合
    if (checkResultRec.Rec.NonFixedMediumNumber > 0) {
      // 確認メッセージを表示
      this.dialogService.openAlertGetMessage('Q0143', ['印刷会社入稿データ作成を実行していない媒体'],
      (closeDetail) => {
        this.eventAlert2_CLICKHandler(closeDetail);
      });
    } else {
      // メール送信処理
      this.sendOCRDataService.execute(this.kymw2200Model, vo);
    }
  }
}
